import lazyLoading from './lazyLoading'
import AuthLayout from '../components/Layouts/Auth'
import AuthGuard from './guards/auth-guard'
import publicProfileRoutes from './public-profile-routes'
import publicServiceDescriptionRoutes from './public-service-description-routes'

export default [
  {
    path: '',
    component: AuthLayout,
    beforeEnter: AuthGuard,
    redirect: { name: 'login' },
    children: [
      {
        name: 'login',
        path: 'login',
        component: lazyLoading('Auth/Login'),
      },
      {
        name: 'register',
        path: 'register',
        component: lazyLoading('Auth/Register'),
      },
      {
        name: 'register_free',
        path: 'register/free',
        component: lazyLoading('Auth/FreeAccountRegister'),
      },
      {
        name: 'forgot-password',
        path: 'forgot-password',
        component: lazyLoading('Auth/ForgotPassword'),
      },
      {
        name: 'reset-password',
        path: 'reset-password/:token',
        component: lazyLoading('Auth/ResetPassword'),
      },
      {
        name: 'downloadReports',
        path: 'download-report',
        component: lazyLoading('DownloadReport/Index'),
      },
      ...publicProfileRoutes,
      ...publicServiceDescriptionRoutes
    ],
  },
]
